const MODEL_COLORS = [
  "rgba(41,  143, 254, 1)",
  "rgba(150, 210, 103, 1)",
  "rgba(168, 116, 233, 1)",
  "rgba(253, 173, 21,  1)",
  "rgba(13,  201, 212, 1)",
  "rgba(109, 41,  254, 1)",
  "rgba(250, 41,  254, 1)",
  "rgba(26,  171, 24,  1)",
  "rgba(199, 254, 41,  1)",
  "rgba(234, 109, 39,  1)",
  "rgba(185, 185, 185, 1)",
  "rgba(255, 115, 115, 1)",
  "rgba(215, 191, 156, 1)",
  "rgba(120, 144, 205, 1)",
  "rgba(200, 70,  70,  1)",
];

const DATASET_COLORS = {
  SUCCESS:          "rgba(42,  198, 112, 1)",
  DANGER_HIGH:      "rgba(255, 66,  66,  1)",
  WARNING_HIGH:     "rgba(255, 124, 50,  1)",
  DANGER_LOW:       "rgba(70,  129, 218, 1)",
  WARNING_LOW:      "rgba(198, 182, 42,  1)",
  BRANDY:           "rgba(217, 184, 135, 1)",
  PURPLE:           "rgba(156, 135, 217, 1)",
  ORANGE:           "rgba(198, 108, 42, 1)",
  CYAN:             "rgba(153, 243, 255, 1)",
};

export {
  MODEL_COLORS,
  DATASET_COLORS,
};
